var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5C1.5 3.89543 2.39543 3 3.5 3H17.5C18.6046 3 19.5 3.89543 19.5 5V13.75C19.5 14.8546 18.6046 15.75 17.5 15.75H3.5C2.39543 15.75 1.5 14.8546 1.5 13.75V5Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92131 4.30287C2.41709 3.84067 2.74409 3 3.4281 3H17.5719C18.2559 3 18.5829 3.84067 18.0787 4.30287L12.5272 9.39176C11.3802 10.4431 9.61979 10.4431 8.47283 9.39176L2.92131 4.30287Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.22c17b6ee0d728dd083eee47d4c651f2.svg";
export { ForwardRef as ReactComponent };